import { NgModule, ModuleWithProviders } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
  INavData
} from '@coreui/angular';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import {
  BsDatepickerModule,
  BsDropdownModule,
  TabsModule,
  AlertModule,
  ModalModule,
  TooltipModule,
  TypeaheadModule
} from 'ngx-bootstrap';

import { DefaultLayoutComponent, SimpleLayoutComponent } from './containers';
import { LayoutConfiguration, LAYOUT_CONFIGURATION_TOKEN } from './tokens';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { NgSpinKitModule } from 'ng-spin-kit';
import { TranslateModule } from '@ngx-translate/core';
import { CommonUtilStateManagementModule } from '@ecosure-suite/common/util-state-management';


@NgModule({
  imports: [
    AlertModule.forRoot(),
    CommonModule,
    CommonUtilStateManagementModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    BsDropdownModule,
    ModalModule.forRoot(),
    BsDatepickerModule,
    NgSpinKitModule,
    PerfectScrollbarModule,
    ReactiveFormsModule,
    RouterModule,
    SweetAlert2Module.forRoot({
      buttonsStyling: false,
      customClass: 'modal-content',
      confirmButtonClass: 'btn btn-primary',
      cancelButtonClass: 'btn'
    }),
    TabsModule,
    TooltipModule.forRoot(),
    TranslateModule.forChild(),
    TypeaheadModule.forRoot()
  ],
  declarations: [DefaultLayoutComponent, SimpleLayoutComponent],
  exports: [
    DefaultLayoutComponent,
    AlertModule,
    ModalModule,
    BsDatepickerModule,
    NgSpinKitModule,
    ReactiveFormsModule,
    TabsModule,
    TooltipModule,
    TranslateModule,
    TypeaheadModule,
    SimpleLayoutComponent,
    SweetAlert2Module
  ],
  entryComponents: [DefaultLayoutComponent]
})
export class CommonUiLayoutsModule {
  static forRoot(
    configuration: LayoutConfiguration
  ): ModuleWithProviders<CommonUiLayoutsModule> {
    return {
      ngModule: CommonUiLayoutsModule,
      providers: [
        {
          provide: LAYOUT_CONFIGURATION_TOKEN,
          useValue: configuration
        }
      ]
    };
  }
}
